/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import { mix } from 'polished';

export default function lerpScoreColors(
  lowerBoundScore: number,
  upperBoundScore: number,
  colorPalette: string[],
) {
  const result = [];
  for (let score = lowerBoundScore; score <= upperBoundScore; score += 1) {
    const colorPoint =
      (score - lowerBoundScore) *
      ((colorPalette.length - 1) / (upperBoundScore - lowerBoundScore));
    const colorIndex = Math.floor(colorPoint);
    const colorLerp = colorPoint - colorIndex;
    const color =
      colorLerp < 0.01
        ? colorPalette[colorIndex]
        : mix(
            colorLerp,
            colorPalette[colorIndex + 1],
            colorPalette[colorIndex],
          );

    result.push({ color, score });
  }

  return result;
}
